import { Version } from '@core/version/version';

export const CORE_VERSION = new Version('1.0.1').full;
